var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoX22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H18C20.2091 0 22 1.79086 22 4V18C22 20.2091 20.2091 22 18 22H4C1.79086 22 0 20.2091 0 18V4Z",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4507 5.5H16.2908L12.2708 10.1595L17 16.5H13.297L10.3967 12.6545L7.07815 16.5H5.23696L9.53678 11.5162L5 5.5H8.79697L11.4186 9.01492L14.4507 5.5ZM13.8049 15.3831H14.8245L8.24294 6.55826H7.1488L13.8049 15.3831Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoX22);
export default __webpack_public_path__ + "static/media/logo-x-22.c143901977f5573047602714a993c44d.svg";
export { ForwardRef as ReactComponent };